import { request as http } from '@/utils/http'
import type { PageResponse } from '@/types/api'
import type {
  WarehouseFclPageRequest,
  WarehouseFclListVO,
  WarehouseFclDetailVO,
  BatchDeleteRequest,
  WarehouseFclBatchStatusRequest
} from './types'

// 新建保存运价库整箱运价
export const save = (params: Record<string, unknown>) => {
  return http.post<number>('/price/warehouse/fcl/save', params)
}

// 修改运价库整箱运价
export const update = (params: Record<string, unknown>) => {
  return http.post<boolean>('/price/warehouse/fcl/update', params)
}

// 分页查询运价库整箱运价
export const page = (params: WarehouseFclPageRequest) => {
  return http.post<PageResponse<WarehouseFclListVO>>('/price/warehouse/fcl/page', params)
}

// 获取运价库整箱运价详情
export const get = (id: string | number) => {
  return http.post<WarehouseFclDetailVO>('/price/warehouse/fcl/get', { id })
}

// 批量删除运价库整箱运价
export const batchDelete = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/warehouse/fcl/batch-delete', params)
}

// 批量修改状态（启用/禁用）
export const batchUpdateStatus = (params: WarehouseFclBatchStatusRequest) => {
  return http.post<boolean>('/price/warehouse/fcl/batch-update-status', params)
}
